
        
        function render() {
          var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"data-name":"חץ ימינה","xmlns":"http://www.w3.org/2000/svg","width":"12.033","height":"22.12"}},[_c('g',{attrs:{"data-name":"חץ ימינה","fill":"#cbe5c0"}},[_c('path',{attrs:{"data-name":"Rectangle 15","d":"M0 10.983l1.009 1.02L11.88 1.02 10.871 0z"}}),_c('path',{attrs:{"data-name":"Rectangle 15 copy","d":"M.153 11.137L11.024 22.12l1.009-1.02L1.162 10.118z"}})]),_c('path',{attrs:{"data-name":"Color Overlay","d":"M12.033 21.1L2.018 10.983 11.88 1.02 10.871 0 0 10.983l.5.5L11.024 22.12z","fill":"#213519"}})]);
        };
      

        module.exports = {
          
          render: render,
        };
      